<template>
  <div class="iframe-box">
    <iframe id="iframe-l" :src="src" frameborder="0" scrolling="no"></iframe>
  </div>
</template>
<script>
export default {
  computed: {
    src() {
      let queryString = Object.keys(this.$route.query).map(key => key + '=' + this.$route.query[key]).join('&');
      return '//www.minhngoc.net.vn/' + this.$route.params.goPath + queryString
    }
  },
  mounted() {
    console.log('go...', this.$route.params.goPath, this.$route.query)
  }
}
</script>
<style lang="scss">
.my-result {
  height: 450px;
  margin-bottom: 10px;
}
.iframe-box {
  overflow: hidden;
}
#iframe-l {
  overflow: hidden;
  height: 3600px !important;
  margin-left: -210px;
  margin-top: -180px;
  width: 740px;
  max-width: none;
}
</style>
